import React, { useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import CustomUploadButton from 'react-firebase-file-uploader/lib/CustomUploadButton';
import { getDownloadURL, storage } from "../../firebase";
import './image-uploader.scss';
import { FaSkull } from 'react-icons/fa';
import { FaEdit } from 'react-icons/fa';

const ImageUploader = ({fileName, disabled, label, onUploadError, onUploadSuccess, value}) => {
	const [isUploading, setIsUploading] = useState(false);
	const [imageUrl, setImageUrl] = useState(value);
	const [progress, setProgress] = useState(imageUrl ? 100 : 0);

	useEffect(() => {
			setImageUrl(value);
	}, [value]);

	const handleUploadStart = () => {
		setIsUploading(true);
		setProgress(0);
		setImageUrl(null);
	};

  const handleProgress = progress => {
		setProgress(progress)
	};
  const handleUploadError = error => {
    setIsUploading(false);
		onUploadError(error);
  };
  const handleUploadSuccess = async filename => {
		setProgress(100);
		setIsUploading(false);
		const url = await getDownloadURL(filename);
		setImageUrl(url);
		onUploadSuccess(url);
  };

	const renderButton = () => {
		if (imageUrl) {
			return (
				<FaEdit />
			);
		}
		return (
			<div className="album-image">
				<div className="image-upload-button">
					<div className="image-upload-button-content">
						<span className="image-upload-icon">
							<FaSkull />
						</span>
						<span>{label || 'Upload Image'}</span>
					</div>
					{isUploading && renderLoader()}
				</div>
			</div>
		);
	}

	const renderLoader = () => {
		const width = `${progress}%`;
		return (
			<div className="meter">
			  <span style={{width: width}}></span>
			</div>
		);
	}

	return (
		<div className={ imageUrl ? 'form-element image-uploader image-selected' : 'form-element image-uploader'}>
    {imageUrl && <img src={imageUrl} alt="" />}
		{!disabled &&
			<CustomUploadButton
	      accept="image/*"
	      name='thumbnail'
	      metadata={{cacheControl: 'public,max-age=31536000'}}
	      storageRef={storage().ref()}
	      onUploadStart={handleUploadStart}
	      onUploadError={handleUploadError}
	      onUploadSuccess={handleUploadSuccess}
	      onProgress={handleProgress}>
				{renderButton()}
	  	</CustomUploadButton>
		}
		</div>
	)
};

ImageUploader.propTypes = {
	fileName: PropTypes.string,
	label: PropTypes.string,
	disabled: PropTypes.bool,
	onUploadError: PropTypes.func,
	onUploadSuccess: PropTypes.func,
	value: PropTypes.string
};

export default ImageUploader;
